import React, { useEffect, useState } from 'react';
// import './dataTableDishes.scss';
import { DataGrid } from '@mui/x-data-grid';
import { chargesColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, deleteDoc, doc, getDoc, onSnapshot, orderBy,query } from "firebase/firestore";
import { db } from '../../firebase'



const DataTable = () => {

  const [ data, setData ] = useState([])

  const [ isLoading, setIsLoading ] = useState(true)


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }

  useEffect(() => {
   
    
//LISTEN REAL TIME

    const collectionRef = collection(db, "charges")

    const queryCharges = query(collectionRef)

    const unsub = onSnapshot(queryCharges, (snapShot) => {

      let list = [];

      snapShot.docs.forEach((doc) => {

        list.push({ id: doc.id, ...doc.data(), date: doc.data().timeStamp.toDate().toLocaleString()})

      })

      setData(list)

      setIsLoading(false)

    }, 
      (error) => {
        console.log(error)
      }
    );

    return () => {
      unsub();
    }

//END LISTEN REAL TIME    

  },[])


      // const getChargesData = async() => {

      //   const docRef = doc(db, "charges", "2cfwzMlON0mZSpCZ05xB");
        
      //     const docSnap = await getDoc(docRef);

          
      //     if (docSnap.exists()) {
    
      //       setData(docSnap.data())

           
      //     } else {
    
      //       console.log("No such document!");
      //     }
      // }
    
      // useEffect(()=>{

      //   getChargesData()

      // }, [])

  console.log(data)


  const handleDelete = async (id) => {

    try{

      await deleteDoc(doc(db, "charges", id));
      setData(data.filter((item) => item.id !== id))

    }catch(err){

      console.log(err)

    }
   
  }

  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 140, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                       <Link to={`/charges/${params.row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>
                        <Link to={`/charges/edit/${params.row.id}`} style={{textDecoration:"none"}}>
                        <div className="viewbutton">Edit</div>
                     </Link>
                       
                       {/* <div className='deletebutton' onClick={() => handleDelete(params.row.id)}>Delete</div> */}
                    </div>
                )
            }
    }
      
  ]  

  return (
    <div className="datatable">
      <div className='datatableTitle'>
        All Charges in Naira
        <Link to="/charges/new"  style={{textDecoration:"none"}} >
          <div className='link'>
            Edit Charges
          </div>
        </Link>
      </div>
      {isLoading ? <Spinner/> : 
        <DataGrid
            className="chargesTableGrid"
            rows={data}
            columns={chargesColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[10]}
            checkboxSelection
        />
    }
    </div>
  )
}

export default DataTable